import { render, staticRenderFns } from "./WxMyInfo.vue?vue&type=template&id=7809fcaf&scoped=true&"
import script from "./WxMyInfo.vue?vue&type=script&lang=js&"
export * from "./WxMyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7809fcaf",
  null
  
)

export default component.exports